import React from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import AppConfig from '../../AppConfig';
import {BorderlessButton} from '../react-button-package/ButtonPackage';

import './react-native-components-in-react.css';
import {IsPWA} from '../pwa-helper/pwa-helper';

export const ModalWrapper = (props) => {
    let className = '';
    let contentClassName = '';
    let bodyClassName = '';

    if (IsPWA()) {
        className = 'pwa-modal'
        contentClassName = 'pwa-modal-content';

        if(!props.windowMode){
            bodyClassName = props.hideHeader ? 'pwa-modal-body-full' : 'pwa-modal-body';
        }
    }

    return (
        <Modal
            isOpen={props.visible}
            toggle={props.onRequestClose}
            className={className}
            contentClassName={contentClassName + ' ' + props.contentClassName}
            style={props.style}
        >
            {props.hideHeader ? null : (
                <ModalHeader
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        padding: '0 5px',
                    }}
                    className={'pwa-modal-header'}
                >
                    <BorderlessButton
                        text={TModalWrapper[AppConfig.lang].CLOSE}
                        onPress={props.onRequestClose}
                    />
                </ModalHeader>
            )}
            <ModalBody
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    ...props.bodyStyle
                }}
                className={bodyClassName}
            >
                {props.children}
            </ModalBody>
            {
                props.footer ?
                    <ModalFooter>
                        {props.footer}
                    </ModalFooter>
                :
                null
            }
        </Modal>
    );
};

const TModalWrapper = {
    // English
    enUS: {
        CLOSE: 'Close',
    },
    // Spanish
    esMX: {
        CLOSE: 'Cerrar',
    },
};